<template>
  <div>
    <v-layout row wrap class="pl-ranges">
      <v-flex md8>
        <range-table/>
      </v-flex>

      <v-flex md4>
        <v-list class="pl-ranges-list" three-line>
          <range-list-item
            v-for="range in currentRanges"
            :range="range"
            :key="range['.key']"
            class="list-item"
          />
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import RangeTable from '@/components/Range/RangeTable'
import RangeListItem from '@/components/Range/RangeListItem'

export default {
  name: 'RangeList',

  components: {
    RangeTable,
    RangeListItem
  },

  computed: {
    ...mapGetters('ranges', ['currentRanges']),
    ...mapState('filters', ['currentFilters'])
  },

  methods: {
    ...mapActions('ranges', ['getRanges', 'clearRanges']),
    ...mapActions('filters', ['getCurrentFilters'])
  },

  mounted () {
    this.getCurrentFilters(this.$route.params.subcategoryId)
  },

  created () {
    this.clearRanges()

    if (this.$route.params.filterId) {
      return this.getRanges(this.$route.params.filterId)
    }
  }
}
</script>
